<template>
  <div>
    <el-dialog
      :visible="showDialog"
      width="80%"
      class="chartDia"
      @close="close"
    >
      <div slot="title" class="slotTit">综合服务费</div>
      <div
        v-if="mode !== 'table'"
        style="margin-bottom:15px;color:#666;text-align:left;display:flex;justify-content:space-between;"
      >
        <span>
          【综合服务费扣减】产生原因：由于您导入的项目参与人在指定供应商完税额度超过供应商对应服务费发放区间，此举将产生额外的完税费用。综合服务费扣减=应收取服务费-已收服务费，应收服务费=累计结算金额*实际服务费率；
        </span>
      </div>
      <div v-if="mode !== 'table'" class="search-box">
        <div class="search-left">
          <div style="margin-right:20px;">
            <span>项目参与人:</span>
            <el-input
              placeholder="请输入项目参与人"
              v-model="searchQuery.fullName"
              style="width:180px;"
              clearable
            />
          </div>
          <div>
            <span>手机号:</span>
            <el-input
              placeholder="请输入手机号"
              v-model="searchQuery.userPhone"
              style="width:150px;"
              clearable
            />
          </div>
        </div>
        <div class="search-right">
          <el-button type="primary" @click="searchEvent">查询</el-button>
        </div>
      </div>
      <el-table
        class="table-box"
        v-loading="loading"
        :data="tableData"
        border=""
        style="width: 100%;padding: 0;"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="fullName"
          label="项目参与人"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userPhone"
          label="手机号"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="累计结算收入"
        >
          <template slot-scope="{ row }">
            <span v-if="mode === 'table'">
              {{ row.sumProjectPrice | moneyFixed }}
            </span>
            <el-button v-else type="text" @click="showComponent('leiji', row)">
              {{ row.sumProjectPrice | moneyFixed }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="累计已收取服务费"
        >
          <template slot-scope="{ row }">
            <span v-if="mode === 'table'">
              {{ row.csoSumPayServicePrice | moneyFixed }}
            </span>
            <el-button v-else type="text" @click="showComponent('leiji2', row)">
              {{ row.csoSumPayServicePrice | moneyFixed }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="实际服务费率"
        >
          <template slot-scope="{ row }">
            {{ row.csoServiceScale | transScale }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="应收取服务费"
        >
          <template slot-scope="{ row }">
            {{ row.csoThisPayServicePrice | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="综合服务费"
        >
          <template slot-scope="{ row }">
            {{ row.zongheMin | moneyFixed }}
          </template>
        </el-table-column>
      </el-table>
      <el-button
        v-if="mode !== 'table'"
        @click="close"
        type="primary"
        style="margin-top:20px;"
      >
        确认
      </el-button>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </el-dialog>
    <component
      v-if="mode !== 'table'"
      :is="componentName"
      :activeId="activeId"
    ></component>
  </div>
</template>
<script>
import leiji from './child/leijijiesuan.vue';
import leiji2 from './child/leijiyishouqu.vue';
import { pageInation } from '@/Mixin/listMixin';
import { comprehensive } from '@/api/ajax';

export default {
  inject: {
    itemData: {
      default: () => ({ data: '' })
    }
  },
  mixins: [pageInation],
  props: {
    mode: {
      type: String,
      default: ''
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    csoId: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    leiji,
    leiji2
  },
  data() {
    return {
      getList: comprehensive.comprehensivePeopleList, // 获取列表的AJAX
      searchQuery: {
        orderId: this.itemData.data.comprehensiveOrderId
      },
      componentName: '',
      activeId: ''
    };
  },

  methods: {
    close() {
      // Object.assign(this.$data, this.$options.data());
      this.paginationData.pageNo = 1;
      if (this.mode === 'table') {
        this.$nextTick(() => {
          this.remove();
        });
      }

      this.$parent && (this.$parent.componentName = '');
    },
    showComponent(componentName, row) {
      this.activeId = row.id;
      this.componentName = componentName;
    }
  },
  created() {
    if (this.mode === 'table') {
      return (this.searchQuery['orderId'] = this.csoId);
    }
  }
};
</script>
<style scoped>
table tr {
  border: 1px solid #a3d0fd;
}
</style>
